/* eslint-disable no-param-reassign,no-underscore-dangle,no-useless-concat */

xplenty.directive('inputCheckbox', [
  '$timeout',

  function ($timeout) {
    return {
      restrict: 'E',

      template:
        '<label class="input-checkbox" ng-class="{disabled: disabled}"><i class="fa" ng-class="{' +
        "'fa-square-o'" +
        ':!_checked, ' +
        "'fa-check-square'" +
        ':_checked }"></i> <input name="{{name}}" type="checkbox" ng-model="_checked" ng-change="onChange(_checked)"/> <span>{{text}}</span> <i class="fa fa-exclamation-circle input-checkbox-hint" ng-if="hasHint"></i></label>',

      replace: true,

      scope: {
        checked: '=ngModel',
        trueValue: '<?',
        falseValue: '<?',
        change: '&?',
        disabled: '<',
      },

      link(scope, element, attrs) {
        scope.hasHint = angular.isDefined(attrs.hint);

        scope.name = attrs.name;
        scope.text = attrs.labelText || 'Provide label text to label-text attribute';

        if (scope.hasHint) {
          $timeout(function () {
            element.find('.input-checkbox-hint').tooltip({
              placement: 'right',
              title: attrs.hint,
            });
          });
        }
      },
      controller: [
        '$scope',
        function ($scope) {
          if (angular.isUndefined($scope.trueValue)) $scope.trueValue = true;
          if (angular.isUndefined($scope.falseValue)) $scope.falseValue = false;
          if (angular.isUndefined($scope.checked)) $scope.checked = $scope.falseValue;

          $scope.onChange = (value) => {
            if (typeof $scope.change === 'function') {
              $scope.change({ value });
            }
          };

          if (typeof $scope.checked === 'boolean') {
            $scope._checked = $scope.checked;
            $scope.$watch('_checked', function (checked) {
              $scope.checked = checked;
            });
          } else if (typeof $scope.checked === 'string') {
            if ($scope.checked === '1' || $scope.checked === '0') {
              $scope._checked = $scope.checked === '1';
              $scope.$watch('_checked', function (checked) {
                $scope.checked = checked ? '1' : '0';
              });
            } else {
              $scope._checked = $scope.checked === $scope.trueValue;
              $scope.$watch('_checked', function (checked) {
                $scope.checked = checked ? $scope.trueValue : $scope.falseValue;
              });
            }
          }
        },
      ],
    };
  },
]);
